import { Pipe, PipeTransform } from '@angular/core';
import dateFormats from '../const/date-formats'
import { Fce } from '../fce';

@Pipe({ name: 'myDate' })
export class MyDatePipe implements PipeTransform {
    constructor() { }

    transform(date: Date | string, format: string|boolean = dateFormats.DATETIME): string {
        if(format === true)
            format = dateFormats.DATETIME;
        if(format === false) 
            format = dateFormats.DATE;
        return date ? Fce.formatDate(date, format) : ''
    }
} 
